var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { IMaskInput } from "react-imask";
import { usePostalCodeTextMask } from "./usePostalCodeTextMask";
/**
 * Renders a text input field with a mask applied for postal codes.
 * This component is designed to dynamically handle postal code input according to different
 * cultural requirements using masks.
 *
 * The component uses `IMaskInput` to apply the mask and manage the input, with the ability to
 * dynamically select the appropriate mask through a dispatch function if required.
 *
 * @component
 * @param {TextFieldVariants} props - The props for the `PostalCodeTextMask` component.
 * @param {function} props.onChange - Callback function that is called when the input value changes.
 * @param {React.Ref} ref - Forwarded ref that can be used to access the DOM input element.
 *
 * @returns {React.ReactElement} A masked input element for postal code input.
 */
export const PostalCodeTextMask = React.forwardRef(function TextMaskCustom(props, ref) {
    const { onChange } = props, other = __rest(props, ["onChange"]);
    const { masks, shouldUseDispatch, dispatch } = usePostalCodeTextMask();
    return (_jsx(IMaskInput, Object.assign({}, other, { mask: masks.map((m) => m.mask) }, (shouldUseDispatch && { dispatch: dispatch }), { inputRef: ref, onAccept: (value) => {
            onChange({ target: { name: props.name, value: value.toUpperCase() } });
        } })));
});
